(function() {
    window.c24 = window.c24 || {};
    window.c24.lp = window.c24.lp || {};

    window.c24.lp.countdown = {
        nextUpdateIn: 10000,
        countdownContainer: null,

        init: function(teaserElement) {
            if (!teaserElement || !teaserElement.classList.contains('countdown')) {
                return;
            }

            this.teaserElement = teaserElement;
            this.countdownContainer = this.teaserElement.querySelector('.countdownContainer') ?? null;

            if (!this.getTargetDate()) {
                return;
            }

            this.updateCountdown();

            if (this.countdownContainer && this.countdownContainer.classList.contains('c24Hidden')) {
                this.countdownContainer.classList.remove('c24Hidden');
            }
        },

        getTargetDate: function() {
            if (!this.countdownContainer) {
                return false;
            }

            const unixTimestamp = Number(this.countdownContainer.dataset.timestamp);

            this.targetDate = new Date(unixTimestamp * 1000);

            // Check if the date is valid
            if (isNaN(this.targetDate.getTime())) {
                return false;
            }
            return true;
        },

        padNumber: function(num) {
            return num < 10 ? '0' + num : num;
        },

        calculateTimeUnits: function() {
            let now = new Date();

            if (this.countdownContainer.dataset.jsFakeDate) {
                now = new Date(Number(this.countdownContainer.dataset.jsFakeDate));
            }

            // calculate remaining seconds (no timezone offset needed)
            const totalSeconds = Math.floor((this.targetDate - now) / 1000);

            // avoid negative values
            const days = Math.max(Math.floor(totalSeconds / (3600 * 24)), 0);
            const hours = Math.max(Math.floor((totalSeconds % (3600 * 24)) / 3600), 0);
            const minutes = Math.max(Math.floor((totalSeconds % 3600) / 60), 0);
            const seconds = Math.max(totalSeconds % 60, 0);

            return {
                days,
                hours,
                minutes,
                seconds,
            };
        },

        displayCountdown: function(days, hours, minutes, seconds) {
            if (this.countdownContainer) {
                this.countdownContainer.querySelector('.numberArea.days').textContent = this.padNumber(days);
                this.countdownContainer.querySelector('.numberArea.hours').textContent = this.padNumber(hours);
                this.countdownContainer.querySelector('.numberArea.minutes').textContent = this.padNumber(minutes);

                this.handleSingularLabels(days, hours, minutes, this.countdownContainer);
                this.scheduleNextUpdate(seconds);
            }
        },

        handleSingularLabels: function(days, hours, minutes, countdownContainer) {
            // days
            if (days === 1 && countdownContainer.querySelector('.labelArea.days').textContent === 'Tage') {
                countdownContainer.querySelector('.labelArea.days').textContent = 'Tag';
            }

            // hours
            if (countdownContainer.querySelector('.labelArea.hours').textContent === 'Stunden') {
                if (hours === 1 && countdownContainer.querySelector('.labelArea.hours').textContent === 'Stunden') {
                    countdownContainer.querySelector('.labelArea.hours').textContent = 'Stunde';
                }
            }

            // minutes
            if (countdownContainer.querySelector('.labelArea.minutes').textContent === 'Minuten') {
                if (minutes === 1 && countdownContainer.querySelector('.labelArea.minutes').textContent === 'Minuten') {
                    countdownContainer.querySelector('.labelArea.minutes').textContent = 'Minute';
                }
            }
        },

        scheduleNextUpdate: function(seconds) {
            const remainingSecondsInMinute = seconds + 1;
            this.nextUpdateIn = remainingSecondsInMinute * 1000;
            if (this.nextUpdateIn > 10000) {
                this.nextUpdateIn = 10000;
            }
            setTimeout(() => this.updateCountdown(), this.nextUpdateIn);
        },

        updateCountdown: function() {
            const {
                days, hours, minutes, seconds,
            } = this.calculateTimeUnits();
            if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0) {
                return; // stopping the countdown if it reaches zero
            }
            this.displayCountdown(days, hours, minutes, seconds);
        },
    };

    document.addEventListener('DOMContentLoaded', () => {
        const countdownElements = document.querySelectorAll('.c24TeaserBlue.countdown');
        countdownElements.forEach((element) => {
            const countdownInstance = Object.create(window.c24.lp.countdown);
            countdownInstance.init(element);
        });
    });
})();
